import PageShell from "@/components/PageShell";
import Solutions from "@/components/Solutions";

export default function SolutionsPage({ onLead }) {
  return (
    <PageShell backdrop="/homes/sol-moveup.webp" title="Mortgage Solutions — My First Home Mortgage Ltd">
      <Solutions onLead={onLead} />
    </PageShell>
  );
}
